<template>
  <div>
    <div class="container">
      <div class="header">
        <div class="left"></div>
        <div class="right"></div>
      </div>
      <p class="form-title">请尽量填写完整信息，以便我们尽快联系您。</p>
      <div class="form">
        <form id="contact_form" method="POST" enctype="multipart/form-data">
          <div class="input clearfix">
            <input type="text" name="company" v-model="form.company" placeholder="公司名(必填)" data-msg="公司名是必填的" />
          </div>
          <div class="input select clearfix">
            <select v-model="form.industry" name="industry" id="" placeholder="行业(必填)" data-msg="行业是必填的">
              <option value="">行业(必填)</option>
              <option :value="application.name" v-for="application in applications" :key="application.id">
                {{ application.name }}
              </option>
            </select>
          </div>
          <div class="input select clearfix">
            <select v-model="form.brand" name="brand" id="" placeholder="品牌" data-msg="品牌">
              <option value="">品牌(必填)</option>
              <option :value="brand.name" v-for="brand in brands" :key="brand.id">
                {{ brand.name }}
              </option>
            </select>
          </div>
          <div class="input clearfix">
            <input type="text" name="name" v-model="form.name" placeholder="姓名(必填)" data-msg="姓名是必填的" />
          </div>
          <div class="input clearfix">
            <input type="text" name="title" v-model="form.title" placeholder="职位(必填)" data-msg="职位是必填的" />
          </div>
          <div class="input clearfix">
            <input type="text" name="mobile" v-model="form.mobile" placeholder="手机(必填)" data-msg="手机是必填的" />
          </div>
          <div class="input clearfix">
            <input type="text" name="email" v-model="form.email" placeholder="邮箱(必填)" data-msg="请填写正确的邮箱地址" />
          </div>
          <div class="input select clearfix">
            <select v-model="form.type" name="type" id="" placeholder="问询类型" data-msg="问询类型">
              <option value="">问询类型(必填)</option>
              <option value="寻求报价">寻求报价</option>
              <option value="售后服务">售后服务</option>
              <option value="产品信息">产品信息</option>
            </select>
          </div>
          <div v-if="!isEmail" class="input input-textarae clearfix">
            <textarea name="message" placeholder="具体内容(必填)" v-model="form.message" data-msg="具体内容是必填的"></textarea>
          </div>
          <div class="button" @click="submit">提交</div>
        </form>
      </div>
    </div>
    <div class="footer">
      <img src="@/assets/footer.png" alt="" />
      <!-- <div class="top"></div>
      <div class="content">
        <div class="qr">
          <img src="@/assets/qr.jpeg" alt="" />
        </div>
        <div class="info">
          <h5>长按左侧二维码关注,了解更多</h5>
          <p>斯必克流体中国</p>
          <p>网址：spxflow.com/cn</p>
          <p>电话：86-21-2208 5888</p>
          <p>售后服务电话：4001-528-008</p>
          <p>邮箱：china.contact@spxflow.com</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { createMessage, getBrands, getApplications } from "@/api/request";
import { Toast } from "vant";
export default {
  data() {
    return {
      form: { industry: "", type: "", brand: "" },
      isEmail: false,
      brands: [],
      applications: [],
      ids: [],
    };
  },
  methods: {
    async load() {
      this.isEmail = !!this.$route.query.isEmail;
      this.ids = this.$route.query.ids || [];
      let app = await getApplications();
      this.applications = app.data;
      let brands = await getBrands();
      this.brands = brands.data;
    },
    async submit() {
      if (!this.form.company) {
        Toast("公司名是必填的");
        return;
      }
      if (!this.form.industry) {
        Toast("行业是必填的");
        return;
      }
      if (!this.form.type) {
        Toast("问询类型是必填的");
        return;
      }
      if (!this.form.brand) {
        Toast("品牌是必填的");
        return;
      }
      if (!this.form.name) {
        Toast("姓名是必填的");
        return;
      }
      if (!this.form.title) {
        Toast("职位是必填的");
        return;
      }
      if (!this.form.mobile) {
        Toast("手机是必填的");
        return;
      }
      if (!this.form.email) {
        Toast("邮箱是必填的");
        return;
      }
      if (!this.form.message) {
        Toast("具体内容是必填的");
        return;
      }

      Toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      const res = await createMessage(this.form);
      if (res.code === 200) {
        Toast.clear();
        Toast("提交成功");
        this.$router.back();
      } else {
        Toast.clear();
      }
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 191px);

  .main {
    padding-top: 40px;
    color: #656464;
    #main-img {
      width: 84%;
      margin: 0 8%;
      margin-bottom: 30px;
      animation: rotation 2s infinite linear;
    }
    h3 {
      font-size: 18px;
    }
    h4 {
      font-size: 18px;
      margin-bottom: 30px;
    }
    p {
      font-size: 13.5px;
      margin: 0 10%;
    }
  }
  .links {
    display: flex;
    margin: 0 10%;
    margin-top: 30px;
    border-right: 1px dashed #ccc;
    .link {
      flex: 1;
      border-left: 1px dashed #ccc;
      img {
        width: 80%;
      }
    }
  }

  .form-title {
    margin: 10px 0;
    margin-top: 40px;
    font-size: 15px;
    text-align: center;
  }

  .form {
    color: #535353;
    background-color: #bbbbbb;
    margin: 30px;
    border-radius: 15px;
    padding: 5px 20px;
    text-align: center;
    .input {
      border-radius: 15px;
      background-color: #fff;
      margin: 10px;
      padding: 5px;
      font-size: 14px;
      *,
      :after,
      :before {
        box-sizing: border-box;
      }
      label {
        position: absolute;
        right: 20%;
        color: #f00;
      }
      input,
      textarea {
        color: #535353;
        appearance: none;
        border: none;
        outline: none;
        width: 100%;
        // float: left;
        padding-left: 10px;
        font-size: 0.8rem;
      }
      select {
        width: 100%;
        height: 21px;
        font-size: 0.8rem;
        padding-left: 8px;
        appearance: none;
        border: 0;
        color: #535353;
        background-color: #fff;
      }
    }
    .input-textarae {
      label {
        margin-top: 25px;
      }
    }
    .button {
      width: 90%;
      border: none;
      border-radius: 15px;
      font-size: 14px;
      padding: 10px;
      margin-bottom: 20px;
      background-color:  #407cca;
      color: #fff;
    }
    p {
      font-size: 12px;
    }
  }
}
</style>
